import React, { useEffect } from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { FailedApproaches } from '../components/FailedApproaches';
import { MechanismSection } from '../components/MechanismSection';
import { WhatYouGet } from '../components/WhatYouGet';
import { AudienceSection } from '../components/AudienceSection';
import { HowItWorks } from '../components/HowItWorks';
import { ProofSection } from '../components/ProofSection';
import { SocialProof } from '../components/SocialProof';
import { FAQSection } from '../components/FAQSection';
import { PricingSection } from '../components/PricingSection';
import { Footer } from '../components/Footer';
import { LiveNotifications } from '../components/LiveNotifications';
import { StickyCTA } from '../components/StickyCTA';
import { initMetaPixel, trackPageView } from '../utils/metaPixel';
export function LandingPage() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  return <main className="min-h-screen bg-cream font-sans text-warmgray selection:bg-terracotta selection:text-white overflow-x-hidden" data-id="element-272">
      <HeroSection data-id="element-273" />
      <ProblemSection data-id="element-274" />
      <FailedApproaches data-id="element-275" />
      <MechanismSection data-id="element-276" />
      <WhatYouGet data-id="element-277" />
      <AudienceSection data-id="element-278" />
      <HowItWorks data-id="element-279" />
      <ProofSection data-id="element-280" />
      <SocialProof data-id="element-281" />
      <FAQSection data-id="element-282" />
      <PricingSection data-id="element-283" />
      <Footer data-id="element-284" />
      <LiveNotifications data-id="element-285" />
      <StickyCTA data-id="element-286" />
    </main>;
}